<template>
  <div class="row" v-if="$store.state.userData">
    <div class="col-sm-12 text-center" v-if="$store.state.userData.statements.length === 0">
      <div class="card">
        <div class="card-content">
          <h2>No Online Statements Available</h2>
        </div>
      </div>
    </div>
    <div class="col-sm-6" v-for="(statement, key) in $store.state.userData.statements" :key="key">
      <div class="card">
        <div class="card-content">
          <div class="row">
            <div class="col-xs-3">
              <div class="text-center icon-danger" style="font-size: 6em; width: inherit"><i class="fa fa-file-pdf-o"></i></div>
            </div>
            <div class="col-xs-9">
              <h4 class="card-title">
                {{ statement.substring(7) }}
              </h4>
              <h6>Download:</h6>
              <button class="btn btn-fill text-center pull-left" style="margin-bottom: 5px;" @click="downloadStatement(statement)"><span class="ti-download"></span> Statement</button> 
              <button style="margin-left: 5px;" v-if="$store.state.userData.inserts[key]" class="btn btn-fill text-center pull-left" @click="downloadInsert(statement)"><span class="ti-download"></span> Insert</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table class="table-striped"
                      :data="[{'test': 5}]"
                      border
                      style="width: 100%">
    </el-table>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Table } from 'element-ui'

  Vue.use(Table) // Imported to fix iOS rendering issues
  export default {
    data () {
      return {
      }
    },
    methods: {
      downloadStatement: function (statement) {
        this.$http({
          url: '/client/downloadStatement/' + statement,
          method: 'GET',
          responseType: 'blob'
        }).then((response) => {
          this.downloadFile(response, statement + ' - ' + this.$store.state.userData.clientData.AuthCode + this.$store.state.userData.clientData.TribalId + ' Statement.pdf')
        })
      },
      downloadInsert: function (statement) {
        this.$http({
          url: '/client/downloadInsert/' + statement,
          method: 'GET',
          responseType: 'blob'
        }).then((response) => {
          this.downloadFile(response, statement + ' - ' + this.$store.state.userData.clientData.AuthCode + ' Insert.pdf')
        })
      },
      downloadFile: function (file, name) {
        const blob = new Blob([file.data], {type: 'application/pdf'})
        if (window.navigator.msSaveOrOpenBlob) { // IE 11+
          window.navigator.msSaveOrOpenBlob(blob, name)
        } else {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          // link.setAttribute('target', '_blank')
          link.setAttribute('download', name)
          document.body.appendChild(link)
          link.click()
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Statements.vue